export const COMPANY = {
  name: "613 Advance",
  phone: "917-622-4379",
  phoneHref: "tel:+19176224379",
  email: "Info@613advance.com",
  hours: "Mon–Fri, 9am – 6pm",
};

export const PRODUCTS = [
  {
    id: "mca",
    name: "Merchant Cash Advance",
    short: "MCA",
    tag: "Most requested",
    desc: "Working capital advanced against your future sales. Payments flex with your revenue, so slow weeks cost you less.",
    points: ["Decisions in as little as 24 hours", "Payments tied to your sales", "Use funds for anything the business needs"],
    img: "/img/owners.jpg",
  },
  {
    id: "heloc",
    name: "HELOC",
    short: "HELOC",
    tag: "Equity",
    desc: "Turn the equity in your property into a revolving line you can draw on for growth.",
    img: "/img/house.jpg",
  },
  {
    id: "equipment",
    name: "Equipment Financing",
    short: "Equipment",
    tag: "Asset-backed",
    desc: "Machinery, vehicles, kitchens, tech. The equipment secures the financing.",
    img: "/img/excavator.jpg",
  },
  {
    id: "loc",
    name: "Business Line of Credit",
    short: "Line of Credit",
    tag: "Revolving",
    desc: "Draw when you need it, pay only on what you use, and reuse it as you repay.",
  },
  {
    id: "sba",
    name: "SBA Loans",
    short: "SBA",
    tag: "Long-term",
    desc: "Government-backed programs with longer terms for established businesses.",
  },
  {
    id: "term",
    name: "Term Loans",
    short: "Term",
    tag: "Fixed schedule",
    desc: "A lump sum with a set repayment schedule, so you can plan around it.",
  },
  {
    id: "factoring",
    name: "Invoice Factoring",
    short: "Factoring",
    tag: "Cash flow",
    desc: "Stop waiting 30, 60 or 90 days. Turn unpaid invoices into cash you can use today.",
    img: "/img/designer.jpg",
  },
];

export const STEPS = [
  { n: "01", title: "Apply in minutes", desc: "Answer a few questions about your business. Checking your options won't affect your credit score." },
  { n: "02", title: "Compare your offers", desc: "A 613 Advance specialist walks you through the products and terms you qualify for." },
  { n: "03", title: "Get funded", desc: "Pick the offer that fits. Approved funds can land in your business account fast." },
];

export const PILLARS = [
  { k: "Speed", v: "Fast decisions", d: "Simple application, minimal paperwork, quick answers." },
  { k: "Flexibility", v: "7 ways to fund", d: "From MCA to SBA, we match the product to the business." },
  { k: "Access", v: "All credit profiles", d: "We look at how your business performs, not just a score." },
  { k: "People", v: "A real specialist", d: "One point of contact from application to funding." },
];

export const INDUSTRIES = [
  { name: "Restaurants & Food", img: "/img/chef.jpg" },
  { name: "Auto & Repair", img: "/img/garage.jpg" },
  { name: "Construction", img: "/img/excavator.jpg" },
  { name: "Retail & Cafés", img: "/img/hero.jpg" },
];

export const FAQS = [
  { q: "Will checking my eligibility hurt my credit?", a: "No. Checking your options with 613 Advance does not require a hard credit pull. If you move forward with a specific product, the lender may need additional review." },
  { q: "How fast can I get funded?", a: "It depends on the product. Merchant cash advances and invoice factoring can move very quickly, often within days. SBA loans and HELOCs take longer because of their underwriting requirements." },
  { q: "What do I need to apply?", a: "Usually basic business details, recent business bank statements and your contact information. Your specialist will tell you exactly what your chosen product needs." },
  { q: "What's the difference between an MCA and a loan?", a: "A merchant cash advance is a purchase of a portion of your future sales, repaid as a percentage of revenue. A loan is borrowed money repaid on a fixed schedule with interest." },
  { q: "Can I qualify with less-than-perfect credit?", a: "Often, yes. Products like merchant cash advances weigh your business revenue and cash flow heavily, so a lower score doesn't automatically rule you out." },
];

export const AMOUNTS = ["$5,000 – $25,000", "$25,000 – $50,000", "$50,000 – $100,000", "$100,000 – $250,000", "$250,000 – $500,000", "$500,000 – $1,000,000", "$1,000,000+"];
export const INDUSTRY_OPTIONS = ["Restaurant / Food Service", "Retail", "Construction / Contractor", "Trucking / Transportation", "Auto Services", "Healthcare / Medical", "Professional Services", "Beauty / Salon", "Manufacturing", "Real Estate", "E-commerce", "Other"];
export const CREDIT = ["Excellent (720+)", "Good (680–719)", "Average (600–679)", "Poor (below 600)"];
export const DEBT = ["None", "Low", "Medium", "High"];
export const BANK = ["Business", "Personal"];
export const REVENUE = ["Under $10,000", "$10,000 – $25,000", "$25,000 – $50,000", "$50,000 – $100,000", "$100,000 – $250,000", "$250,000+"];
